<template>
  <div class="offers-list">
    <div class="offers-list__head" aria-hidden="true">
      <div>{{ i18n.offers_head_pieces }}</div>
      <div>{{ i18n.offers_head_price }}</div>
    </div>

    <div class="offers-list__list">
      <button
        type="button"
        :class="{ 'offers-list__item': true, 'is-active': activeCustomOffer && activeCustomOffer.amount === offer.amount }"
        v-for="(offer, index) in offers"
        :key="index"
        @click="() => setActiveOffer(offer)"
      >
        <div class="offers-list__item__row">
          <div class="offers-list__item-col">
            <span class="sr-only">{{ i18n.amount }} </span><strong>{{ offer.amount }}</strong>
          </div>

          <div class="offers-list__item-col">
            <div class="offers-list__item-price mb-1">
              <span class="sr-only">{{ i18n.price }}</span>
              <strong><price :price="offer.price" /></strong>
            </div>

            <div class="offers-list__item-price-piece">
              <price :price="offer.price_per_piece" /> {{ i18n.per_piece }}
            </div>

            <div class="offers-list__item-discount" v-if="offer.discount_percentage">
              <span class="d-md-none">-</span>{{ offer.discount_percentage }}% <span class="d-none d-md-inline">{{ i18n.discount }}</span>
            </div>
          </div>
        </div>

        <div class="offers-list__cutting-costs" v-if="offer.cutting_costs && offer.cutting_costs > 0">
          {{ i18n.cutting_costs }} <price :price="offer.cutting_costs" />
          <button class="btn--reset offers-list__modal-toggle" type="button" @click="onCuttingCostsModalOpen" v-if="cuttingCostsModal">
            <icon identifier="info" />
            <span class="sr-only">Info</span>
          </button>
        </div>
      </button>
    </div>
  </div>
</template>

<script>
import Price from './Price';
import Icon from './Icon';
import {mapGetters} from "vuex";

export default {
  components: {
    Icon,
    Price,
  },

  props: {
    offers: Array,
  },

  computed: {
    ...mapGetters([
      'activeCustomOffer',
    ]),

    cuttingCostsModal() {
      return this.$store.getters.modalForIdentifier('cutting_costs');
    },
  },

  methods: {
    setActiveOffer(offer) {
      this.$emit('change', offer);
    },

    onCuttingCostsModalOpen() {
      this.$store.commit('setModalTitle', this.cuttingCostsModal.title);
      this.$store.commit('setModalContent', this.cuttingCostsModal.content);
      this.$store.commit('setModalOpen', true);
    },
  }
};
</script>

<style scoped>
.offers-list__head {
  display: flex;
  font-weight: 700;
  margin-bottom: .75rem;
}

.offers-list__head > div:first-child {
  width: calc(30% + .25rem);
  flex: 0 0 auto;
}

.offers-list__item {
  display: block;
  width: 100%;
  background-color: #fbf8f4;
  border: 1px solid #f4ece1;
  padding: 1rem 1rem 1rem 3.75rem;
  margin-bottom: .75rem;
  appearance: none;
  text-align: left;
  cursor: pointer;
  position: relative;
  transition: background-color .3s ease-out;
}

.offers-list__item:before,
.offers-list__item:after {
  content: '';
  width: 1.5rem;
  height: 1.5rem;
  background-color: #fff;
  border: 1px solid #eee;
  border-radius: 50%;
  position: absolute;
  top: 50%;
  left: 1rem;
  margin-top: -.75rem;
}

.offers-list__item:after {
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' x='0' y='0' viewBox='0 0 32 32' width='32' height='32'%3E%3Cpath fill='%23297b4a' d='M82.9-85.1c-1.1 7-7.5 12.3-14.9 12.3-.7 0-1.5-.1-2.2-.2-8.1-1.2-13.7-8.6-12.6-16.5.9-6.4 5.6-11.3 11.8-12.1.2-.1.3-.1.5-.2.3-.1.6-.1.9-.1.7-.1 1.3-.1 2-.1 4.3 0 8.1 1.7 10.7 4.8 3 3.7 4.4 8.1 3.8 12.1zm-6.3-9.7c-2.1-2.3-4.6-3.5-7.5-3.7-.3.2-.7.4-1.1.3-.4 0-.7-.1-1.1-.1-5.3 0-9.6 3.6-10.5 8.7-1 6 3 11.8 9.1 13 .7.1 1.5.2 2.2.2 6.5 0 10.8-4.3 11.7-8.6.7-3.4-.3-7.1-2.8-9.8zm-12 14.7c-1.2-1.2-2.3-2.6-3.4-3.9-.9-1-1.7-2.1-2.7-3.1.8-.5 1.7-1 2.6-1.6l3 3.8c.3.4.6.4.8.4.3 0 .5-.1.8-.3.1 0 .2-.1.2-.2l7.7-9.6 1.9 2.8c-1.1 1.1-4.1 5-5.1 6.1-3.1 3.4-2.1 2.6-5.8 5.6zM.2 16.4c1.5-.9 3.1-1.8 4.8-2.9l6.6 7.9L28.2 2.6l3.5 5.2-20.1 21.6-11.4-13z'/%3E%3C/svg%3E ");
  background-size: 100% auto;
  background-position: center center;
  width: 1rem;
  height: 1rem;
  margin-top: -.5rem;
  left: 1.25rem;
  border: 0;
  display: none;
}

.offers-list__item:hover,
.offers-list__item:focus {
  background-color: #f1ede7;
}

.offers-list__item.is-active {
  background-color: #fff;
  border-color: rgba(67, 151, 101, .7);
  box-shadow: 0 2px 10px -2px rgba(67, 151, 101, .7);
}

.offers-list__item.is-active:after {
  display: block;
}

.offers-list__item:last-child {
  margin-bottom: 0;
}

.offers-list__item__row {
  display: flex;
  align-items: center;
}

.offers-list__item-col {
  position: relative;
}

.offers-list__item-col:first-child {
  width: 30%;
  flex: 0 0 30%;
}

.offers-list__item-col:last-child {
  width: 70%;
  flex: 0 0 70%;
  padding-right: 4rem;
  min-height: 1.875rem;
}

.offers-list__cutting-costs {
  font-size: .875rem;
  padding-top: .75rem;
}

.offers-list__item-discount {
  padding: .375rem .5rem;
  background-color: #ee8e25;
  color: #fff;
  font-size: .875em;
  font-weight: 700;
}

.offers-list__item-col .offers-list__item-discount {
  position: absolute;
  top: 50%;
  right: 0;
  transform: translateY(-50%);
}

.offers-list__item-price {
  font-size: 1rem;
}

.offers-list__modal-toggle :global(svg) {
  width: 1rem;
  height: 1rem;
  fill: currentColor;
  display: inline-block;
  vertical-align: middle;
  margin-top: -.25rem;
  margin-left: .25rem;
}
</style>
